//@ts-nocheck

// Get user session from localStorage
export const getUserSession = () => {
  try {
    const userSession = localStorage.getItem('userSession');
    const userData = userSession ? JSON.parse(userSession) : null;
    const isStaff = Boolean(userData?.userId);

    return userData ? { ...userData, isStaff } : null;
  } catch (e) {
    return null;
  }
};
